import styled, { css } from 'styled-components';
import { inputStyleFactory } from 'components/Form/shared/inputStyleFactory';
import { colors } from 'assets/styled/tokens';

interface WrapperProps {
  width?: string;
}

interface SelectBoxProps {
  size?: 'sm' | 'md' | 'lg';
  isOpen?: boolean;
  width?: string;
  height?: string;
}

interface LeftContentProps {
  isLeftIconBlack?: boolean;
}

interface OptionProps {
  size?: 'sm' | 'md' | 'lg';
}

interface DropdownProps {
  isSearchable?: boolean;
}

interface SearchWrapperProps {
  size?: 'sm' | 'md' | 'lg';
}

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  font-family: Roboto;
  color: ${colors.carbon};
  width: ${({ width }) => width};
`;

export const SelectBox = styled.div<SelectBoxProps>`
  border-radius: ${({ isOpen }) => (isOpen ? '4px 4px 0 0' : '4px')};
  border: 1px solid #e5e5e5;
  ${props => {
    if (props.height) {
      return css`
        height: ${props.height};
        min-height: ${props.height};
        max-height: ${props.height};
        box-sizing: border-box;
      `;
    }
    if (props.size === 'sm') {
      return css`
        height: 24px;
        min-height: 24px;
        max-height: 24px;
        padding: 5px 8px;
        box-sizing: border-box;
      `;
    }
    return inputStyleFactory(props.size as any);
  }};
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: ${({ width }) => width};
  justify-content: space-between;
  box-shadow: ${({ isOpen }) => (isOpen ? '0px 6px 20px 0px #0000004D' : '')};
`;

export const StyledPlaceholder = styled.div`
  font-weight: 400;
  color: ${colors.gray};
`;

export const StyledSelected = styled.div`
  font-weight: 700;
  color: ${colors.carbon};
`;

export const LeftContent = styled.div<LeftContentProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  > svg {
    path {
      fill: ${({ isLeftIconBlack }) => (isLeftIconBlack ? colors.carbon : '#9E9288')};
    }
  }
`;

export const Dropdown = styled.ul<DropdownProps>`
  position: absolute;
  width: 100%;
  top: ${({ isSearchable }) => (isSearchable ? '0' : '64%')};
  z-index: 10;
  background-color: white;
  border: 1px solid #e5e5e5;
  max-height: 200px;
  overflow-y: auto;
  border-radius: ${({ isSearchable }) => (isSearchable ? '4px' : '0 0 4px 4px ')};
  margin-top: ${({ isSearchable }) => (isSearchable ? '0' : '4px')};
  box-shadow: 0px 6px 20px -6px #0000004d;
  scrollbar-width: none;
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Option = styled.li<OptionProps>`
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  ${props => inputStyleFactory(props.size as any)};
  &:hover {
    background-color: #eee;
  }
`;

export const SearchWrapper = styled.div<SearchWrapperProps>`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  ${props => inputStyleFactory(props.size as any)};
  gap: 8px;
`;

export const LeftIcon = styled.div`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* ícone não bloqueia clique no input */
`;

export const RightIcon = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-65%);
  cursor: pointer;
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
  ::placeholder {
    padding: 20px;
    font-family: Roboto;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #7f746a;
  }
`;

export const IconButton = styled.div`
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  color: #888;
`;
